export default "__VITE_ASSET__Dz0XuTr8__"